var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"columns",class:[ _vm.classColunas ],style:(_vm.style)},_vm._l((_vm.colunas),function(item,itemIndex){return _c('div',{staticClass:"column"},_vm._l((_vm.mappedComponents(itemIndex)),function(item,index){return _c(item.component,{key:`${item.type}-${index}`,tag:"component",attrs:{"contents":item.contents}})}),1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }